import script from "./CategoryFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryFormModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryFormModal.vue?vue&type=style&index=0&id=7c2be688&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2be688"]])

export default __exports__